export default __webpack_public_path__ + "static/media/AMR.f0ca8aeb.png";